import { get } from 'lodash';
import { MEDICAL_CERTIFICATE_DOCUMENT_TYPE, MEDICAL_CERTIFICATE_TYPES } from '../../../interfaces/medicalCertificate';

export const getMedicalCertificateLabel = (
  certificateType: MEDICAL_CERTIFICATE_DOCUMENT_TYPE | string | undefined | null,
  professionalIssuer?: string | null
): string => {
  if (!certificateType) return 'Atestado';

  if (certificateType === MEDICAL_CERTIFICATE_DOCUMENT_TYPE.MEDICAL_CERTIFICATE) {
    const issuer = (professionalIssuer ?? '').toUpperCase();
    return get(MEDICAL_CERTIFICATE_TYPES, issuer, 'Atestado');
  }

  return get(MEDICAL_CERTIFICATE_TYPES, certificateType, 'Atestado');
};
